import { Button, ButtonProps, theme } from '@de-id/ui-components';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { MouseEventHandler, ReactNode } from 'react';

const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;

    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
`;

const StyledHoverButton = styled(Button)<ButtonProps>`
    background-color: ${({ color }) => (color === 'outlined' ? theme.colors.white : undefined)};

    font-weight: 600;
    font-size: 14px;
`;

interface Props {
    onClick: MouseEventHandler<HTMLElement>;
    text: string;
    color: ButtonProps['color'];
    icon?: ReactNode;
    id?: string;
}

export const LibraryItemHoverButton = ({ onClick, icon, text, id, color }: Props) => {
    return (
        <Container onClick={onClick}>
            <StyledHoverButton id={id} color={color} size="small">
                {icon}
                <Typography variant="h5">{text}</Typography>
            </StyledHoverButton>
        </Container>
    );
};
